module.exports = __webpack_public_path__ + "img/application.4bd85e3c.png";